import { render, staticRenderFns } from "./NewsViewVer.vue?vue&type=template&id=4c5cdef5&scoped=true"
import script from "./NewsViewVer.vue?vue&type=script&lang=js"
export * from "./NewsViewVer.vue?vue&type=script&lang=js"
import style0 from "./NewsViewVer.vue?vue&type=style&index=0&id=4c5cdef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5cdef5",
  null
  
)

export default component.exports